import { TApplicationState } from '../../types/redux';

export const selectIsBuilderLinkEnabled = (state: TApplicationState) => {
  const { isBuilderLinkEnabled } = state;

  return isBuilderLinkEnabled;
};
